import React, { useState } from 'react';
import { 
  Bot, 
  Server,
  MessageSquare
} from 'lucide-react';
import AIScenariosManagement from '../../components/admin/AIScenariosManagement';
import ModelVendorManagement from '../../components/admin/ModelVendorManagement';
import AIPromptsManagement from '../../components/admin/AIPromptsManagement';

const AIManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState('scenarios');

  const tabs = [
    { id: 'scenarios', name: 'AI场景管理', icon: Bot },
    { id: 'vendors', name: '模型厂商管理', icon: Server },
    { id: 'prompts', name: '提示词管理', icon: MessageSquare }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'scenarios':
        return <AIScenariosManagement />;
      case 'vendors':
        return <ModelVendorManagement />;
      case 'prompts':
        return <AIPromptsManagement />;
      default:
        return null;
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* 页面标题 */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">AI管理</h1>
        <p className="text-gray-600">管理AI场景、模型厂商和提示词模板</p>
      </div>

      {/* 标签导航 */}
      <div className="bg-white rounded-lg shadow mb-6">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8 px-6">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center py-4 px-1 border-b-2 font-medium text-sm ${
                    activeTab === tab.id
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Icon className="w-5 h-5 mr-2" />
                  {tab.name}
                </button>
              );
            })}
          </nav>
        </div>
      </div>

      {/* 标签内容 */}
      {renderTabContent()}
    </div>
  );
};

export default AIManagement;